import { makeStyles } from '@material-ui/styles';
import React from 'react';
const useStyles = makeStyles(() => {
    return {
        container: {
            display: 'flex',
            justifyContent: 'center',
            overflow: 'hidden',
            maxHeight: '150px',
            '& img': {
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain',
                flexGrow: '1'
            }
        }
    };
});
const GifMessage = ({ url }) => {
    const styles = useStyles();
    return (React.createElement("div", { className: styles.container },
        React.createElement("img", { alt: url, src: url })));
};
export default GifMessage;
